<ng-sidebar-container style="height: 100vh;">
	<div ng-sidebar-content>
		<router-outlet></router-outlet>
	</div>
</ng-sidebar-container>
